/**
 * OOTBS SFRA JS code
 * Changed wishlist type toggle event
 * Copied selectSizeAttribute OOTB method
 */
'use strict';

const { queryFirst, queryAll, addClass, removeClass, hasClass, toFormData, matchesBreakpoint, toggleClass, renderFragment, remove, scrollTo } = require('../domUtil');
const { getJSON, appendToUrl } = require('../util');
const { dialogTemplate, addToCartAlert } = require('../templates');
const { WISHLIST_NAME_REGEX } = require('../components/shippingPreference/constants');
const configElement = queryFirst('#wishlist-settings');
const WishlistItemsMgr = require('../wishlist/wishlistItemsMgr').default;

import base from '../product/base';
import { trackWishlist } from '../components/etmc';
import { AlertDialog } from '../components/alertDialog';
import { getCustomerData, getProductInventoryData } from '../utils/ajaxData';
import {
    CLASS_SIZE_SELECTED,
    SELECTOR_AVAILABILITY_MSG_TEXT,
    SELECTOR_EARLY_ACCESS_CTA_SIGN_IN,
    SELECTOR_EARLY_ACCESS_CTA_SIGN_UP,
    SELECTOR_NOTIFY_ME_DIALOG_PID_INPUT,
    SELECTOR_SIZE_BTN,
    SELECTOR_SIZE_LIST,
    SELECTOR_SIZE_SELECTED_ASSISTIVE_TEXT,
    SELECTOR_SIZE_SELECTOR,
    SELECTOR_SOLDOUT_MSG,
    SELECTOR_TILE_PRICE_WRAPPER
} from '../productTiles/productTileConstants';
import { IN_STOCK_STATUS as IN_STOCK, NOT_AVAILABLE_STATUS as NOT_AVAILABLE, PREORDER_STATUS as PREORDER, HIDDEN_CLASS, NOT_AVAILABLE_CLASS, INVALID_CLASS, ACTIVE_CLASS } from '../constants';
import { getProductInfo } from '../productTiles/utils/productTileData';
import notifyMe from '../components/notifyMe';
const { ensureFreshCsrfToken, getFreshCsrfToken } = require('../utils/csrfRefresh');

const focusHelper = require('base/components/focus');
const $body = $('body');
const mainPageContent = queryFirst('.page ');
const { initCarouselElement, SELECTOR_CLASS_SELECTOR_CAROUSEL } = require('../components/swiperCarousel').default;

/**
 * Show allert message
 * @param {AlertConfig} alertConfig alert configuration
 * @returns {void}
 */
function displayAlert(alertConfig) {
    new AlertDialog(alertConfig);
}

/**
 * Return configuration for erro alerts
 * @returns { Object } allert configuration object
 */
function getErrorAlertConfig() {
    const msgContainer = queryFirst('.wishlistItemCards');
    const msg = msgContainer?.dataset?.errorMsg || '';
    return {
        items: [
            {
                text: msg
            }
        ],
        customCSSClass: ['alert-top']
    };
}

/**
 *
 * @param {string} wishListCountMessage
 */
function updateWishlistCountMessage(wishListCountMessage) {
    const detailsItemCount = queryFirst('.wishlist-menu-bar-count');

    if (wishListCountMessage && detailsItemCount) {
        detailsItemCount.textContent = wishListCountMessage;
    }
}

/**
 * Adds Product to wishlist
 * @param {string} pid - productId
 * @param {string} listId - wishlist ID
 * @param {string} customCreateTime - custom time creation for restored items
 */
async function addProductToWishlist(pid, listId, customCreateTime) {
    const url = configElement?.dataset?.wishlistAdditemLink || '';
    const csrfToken = await getFreshCsrfToken();

    await fetch(url, {
        method: 'POST',
        body: toFormData({
            pid: pid,
            id: listId,
            createTime: customCreateTime,
            csrf_token: csrfToken
        })
    })
        .then(response => response.json())
        .then(data => {
            if (data.csrfError) {
                document.body.dispatchEvent(new CustomEvent('csrf:error'));
                return;
            }
            if (data.success) {
                updateWishlistCountMessage(data.wishListCountMessage);

                if (data.wishlistItems.find(i => i.UUID === listId).items.length) {
                    removeClass(queryFirst('.js-share-wishlist'), HIDDEN_CLASS);
                }
                // update Marketing Analytics trackWishlist event
                if (data.mcAnalyticsArray) {
                    trackWishlist(data.mcAnalyticsArray);
                }
                const wishlistMgr = WishlistItemsMgr.getInstance();
                wishlistMgr.updateWishlistItems(data.wishlistItems);
            }

            if (data.error) {
                displayAlert(getErrorAlertConfig());
            }
        })
        .catch(() => {
            displayAlert(getErrorAlertConfig());
        });
}

/**
 *
 * @param {*} shareTitle
 * @param {*} shareText
 * @param {*} shareUrl
 */
function showShareDialogs(shareTitle, shareText, shareUrl) {
    if (navigator.share !== undefined && !matchesBreakpoint('lg')) {
        // if native share available use it
        navigator.share({
            title: shareTitle,
            text: shareText,
            url: shareUrl
        });
    } else {
        // otherwise use share dialog
        $('#share-wishlist').modal('show');
    }
}
/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    if (!response.error) {
        return;
    }
    if (response.displayModal) {
        let addToCartWarningDialog = queryFirst('#add-to-cart-warning-dialog');

        if (!addToCartWarningDialog) {
            const isOnCartPage = window.location.pathname === '/cart/';
            const fragment = renderFragment(
                dialogTemplate({
                    buttons: isOnCartPage ? [{ text: 'OK', primary: true }] : [{ text: 'Close' }, { text: 'Review Tote', primary: true, link: response.redirectLink }],
                    modalContentHeading: response.messageHeading,
                    modalContentBody: isOnCartPage ? response.messageBodyOnCart : response.messageBodyOffCart,
                    id: 'add-to-cart-warning-dialog'
                })
            );

            document.body.appendChild(fragment);
            addToCartWarningDialog = queryFirst('#add-to-cart-warning-dialog');
        }

        $(addToCartWarningDialog).modal('show');
    } else {
        const messageType = response.error ? 'alert-danger' : 'alert-success';
        // show add to cart toast
        remove(queryAll('.add-to-cart-messages'));

        let addToCartMessages = queryFirst('.add-to-cart-messages');
        if (!addToCartMessages) {
            document.body.appendChild(renderFragment('<div class="add-to-cart-messages"></div>'));
            addToCartMessages = queryFirst('.add-to-cart-messages');
        }

        addToCartMessages.appendChild(renderFragment(addToCartAlert(messageType, response.message)));

        setTimeout(() => {
            remove(queryAll('.add-to-basket-alert'));
        }, 5000);
    }
}

/**
 *
 * @param {Object} container - product container html element
 * @param {int} selectedColorValue - selected color id
 * @param {string} selectedSizeValue - Selected size value
 * @param {Object} [productInventory] Product inventory object
 */
async function updateCTAs(container, selectedColorValue, selectedSizeValue, productInventory) {
    const addToCartButton = queryFirst('.js-add-to-cart', container) || queryFirst('#wishlists-add-to-cart .js-add-to-cart');
    const notifyMeButton = queryFirst('.js-wishlist-notify-me.js-desktop-notify-me', container);
    const availabilityMsg = queryFirst('js-wishlist-availability-msg', container);
    const clubLillySignIn = queryFirst(SELECTOR_EARLY_ACCESS_CTA_SIGN_IN, container);
    const soldoutMsgEls = queryAll(SELECTOR_SOLDOUT_MSG, container);
    const { imgOosCls } = container.dataset;
    const tileSlideImages = queryAll('.js-tile-slide-img', container);
    // join
    const clubLillySignUp = queryFirst(SELECTOR_EARLY_ACCESS_CTA_SIGN_UP, container);
    if (clubLillySignIn) {
        addClass(clubLillySignIn, HIDDEN_CLASS);
    }
    if (clubLillySignUp) {
        addClass(clubLillySignUp, HIDDEN_CLASS);
    }

    if (addToCartButton) {
        addClass(addToCartButton, HIDDEN_CLASS);
        removeClass(addToCartButton, 'valid-data');
        addToCartButton.disabled = true;
    }
    addClass(notifyMeButton, HIDDEN_CLASS);
    addClass(availabilityMsg, HIDDEN_CLASS);

    const productInfoVariants = getProductInfo(container);
    const product = productInfoVariants ? productInfoVariants[selectedColorValue] : null;

    let customerData;
    const isEarlyAccessProduct = product?.earlyAccess?.isEarlyAccessProduct;

    if (isEarlyAccessProduct) {
        customerData = await getCustomerData();

        if (customerData.isAuthenticated) {
            if (customerData.isLoyaltyMember) {
                addToCartButton.disabled = !selectedSizeValue;
                addClass(addToCartButton, 'valid-data');
                removeClass(addToCartButton, HIDDEN_CLASS);
            } else {
                removeClass(clubLillySignUp, HIDDEN_CLASS);
            }
        } else {
            removeClass(clubLillySignIn, HIDDEN_CLASS);
        }
    }

    if (!addToCartButton) {
        // if not add to cart, other also should be N/A
        return;
    }

    if (!selectedSizeValue) {
        if (!isEarlyAccessProduct) {
            removeClass(addToCartButton, HIDDEN_CLASS);
        }
        return;
    }

    if (!product) {
        return;
    }
    const { ID: pid, isNotifyMeEnabled, isDirectlyPurchasable, forceOutOfStock } = product.sizes[selectedSizeValue];

    const { masterId } = container.dataset;

    productInventory = productInventory || (await getProductInventoryData(masterId));

    if (!productInventory?.variants?.[pid]) {
        return;
    }

    const { message: availabilityMessage, availabilityStatus } = productInventory.variants[pid];

    const isInStockAvailability = availabilityStatus === IN_STOCK;
    const isNotAvailableAvailability = availabilityStatus === NOT_AVAILABLE;
    const isPreorderAvailability = availabilityStatus === PREORDER;

    toggleClass(tileSlideImages, imgOosCls, isNotAvailableAvailability && !isNotifyMeEnabled);
    if (!isEarlyAccessProduct) {
        if (!isDirectlyPurchasable) {
            addToCartButton.disabled = true;
            removeClass(addToCartButton, 'valid-data');
            addClass([notifyMeButton], HIDDEN_CLASS);
        } else if (availabilityStatus !== NOT_AVAILABLE && !forceOutOfStock) {
            addToCartButton.disabled = false;
            removeClass([addToCartButton], HIDDEN_CLASS);
            addClass(addToCartButton, 'valid-data');
        } else {
            addToCartButton.disabled = true;
            removeClass(addToCartButton, 'valid-data');
        }

        toggleClass(notifyMeButton, HIDDEN_CLASS, !isNotAvailableAvailability || !isNotifyMeEnabled);
        toggleClass(notifyMeButton, 'valid-data', selectedSizeValue);
        notifyMeButton.disabled = !selectedSizeValue;
        toggleClass(soldoutMsgEls, HIDDEN_CLASS, !isNotAvailableAvailability || isNotifyMeEnabled);

        toggleClass(availabilityMsg, HIDDEN_CLASS, !isPreorderAvailability);

        if (isPreorderAvailability) {
            const availabilityMsgText = queryFirst(SELECTOR_AVAILABILITY_MSG_TEXT, container);

            availabilityMsgText.innerHTML = availabilityMessage;
        }
    }
}

/**
 * Size Change handler
 * @param {*} container item container
 * @param {*} sizeEl size element
 * @param {*} selectedSizeValue selected size value
 */
async function onSizeChangeHandler(container, sizeEl, selectedSizeValue) {
    const { masterId, colorId } = container.dataset;
    const productInventory = await getProductInventoryData(masterId);
    removeClass(queryAll(SELECTOR_SIZE_BTN, container), CLASS_SIZE_SELECTED);
    addClass(sizeEl, CLASS_SIZE_SELECTED);
    const sizeContainer = sizeEl.closest(SELECTOR_SIZE_SELECTOR);
    const assistiveElements = queryAll(SELECTOR_SIZE_SELECTED_ASSISTIVE_TEXT, sizeContainer);
    assistiveElements.forEach(eachElement => {
        const { outOfStock } = eachElement.dataset;
        if (eachElement.textContent.includes(outOfStock)) {
            eachElement.textContent = outOfStock;
        } else {
            eachElement.textContent = '';
        }
    });

    const isOOS = hasClass(sizeEl, NOT_AVAILABLE_CLASS);
    const assistiveElementOfSelected = queryFirst(SELECTOR_SIZE_SELECTED_ASSISTIVE_TEXT, sizeEl.closest(SELECTOR_SIZE_LIST));
    if (assistiveElementOfSelected) {
        const { selectedText, outOfStock } = assistiveElementOfSelected.dataset;
        assistiveElementOfSelected.textContent = selectedText;
        if (isOOS) {
            assistiveElementOfSelected.textContent += ' ' + outOfStock;
        }
    }

    container.dataset.pid = sizeEl.dataset.variationId;
    updateCTAs(container, colorId, selectedSizeValue, productInventory);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    const htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="editWishlistProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $body.append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.product-quickview');
    const footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    const $sheet = $('.sheet.show .sheet-dialog');
    $sheet.spinner().start();

    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            const parsedHtml = parseHtml(data.renderedTemplate);
            $('#editWishlistProductModal .modal-body').empty();
            $('#editWishlistProductModal .modal-body').html(parsedHtml.body);
            $('#editWishlistProductModal .modal-footer').html(parsedHtml.footer);
            $('#editWishlistProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editWishlistProductModal .enter-message').text(data.enterDialogMessage);
            $('#editWishlistProductModal').modal('show');
            $body.trigger('editwishlistproduct:ready');
            $.spinner().stop();
        },
        error: function () {
            $sheet.spinner().stop();
        }
    });
}

/**
 * show toast response
 * @param {Object} res - from the call to set the public status of a list or item in a list
 */
function showResponseMsg(res) {
    $.spinner().stop();
    let status;

    if (res.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $body.append('<div class="add-to-wishlist-messages "></div>');
    }

    $('.add-to-wishlist-messages').append('<div class="add-to-wishlist-alert text-center ' + status + '">' + res.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {string} focusElementSelector - selector of the element to focus on
 * @param {HTMLElement} focusElement - element to focus on
 */
async function renderNewPageOfItems(pageNumber, focusElementSelector, focusElement) {
    const { publicView, uuid, href } = queryFirst('.wishlistItemCardsData').dataset;
    const scrollPosition = document.documentElement.scrollTop;
    const isLoggedInState = !!queryFirst('.js-account-active');

    await fetch(`${href}?pageNumber=${pageNumber}&publicView=${publicView}&id=${uuid}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(data => {
            // Clear the wishlistItemCardsWrapper content
            queryFirst('.wishlistItemCardsWrapper').innerHTML = '';

            // Replace the wishlistItemCardsWrapper with the new HTML content
            queryFirst('body .wishlistItemCardsWrapper').outerHTML = data;

            if (isLoggedInState) {
                addClass(queryFirst('body .wishlistItemCardsWrapper'), 'logged-in-state');
            }

            scrollTo(mainPageContent.offsetTop);

            if (focusElementSelector) {
                queryFirst(focusElementSelector).focus();
            } else if (focusElement) {
                focusElement.focus();
            } else {
                // Fallback to scroll position
                document.documentElement.scrollTop = scrollPosition;
            }

            // Stop spinner
            $.spinner().stop();

            const carouselEls = queryAll(SELECTOR_CLASS_SELECTOR_CAROUSEL);

            carouselEls.forEach(el => {
                initCarouselElement(el);
            });
        })
        .catch(error => {
            console.error('Error:', error);

            // Stop spinner on failure
            $.spinner().stop();
        });
}

/**
 * Input validation
 * @param {HTMLInputElement} input input
 * @param {HTMLElement} invalidFeedback validation message
 */
function validateInputCallback(input, invalidFeedback) {
    const listNameTrimText = input && input.value && input.value.trim();
    const { missingError, patternMismatch } = input.dataset;
    if (!listNameTrimText) {
        addClass(input, INVALID_CLASS);
        invalidFeedback.textContent = missingError;
    } else if (!WISHLIST_NAME_REGEX.test(listNameTrimText)) {
        addClass(input, INVALID_CLASS);
        invalidFeedback.textContent = patternMismatch;
    } else {
        removeClass(input, INVALID_CLASS);
    }
}

const CW_MODAL_ID = 'create-wishlist';

/**
 * Syncs aria-expanded on create-wishlist dialog triggers.
 * @param {boolean} isExpanded - whether the dialog is open
 */
function cwSyncExpanded(isExpanded) {
    queryAll(`[aria-controls="${CW_MODAL_ID}"]`).forEach((trigger) => {
        trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
}

/**
 * Focuses the list name field in the create-wishlist dialog.
 * @param {HTMLElement} [modalEl] - create-wishlist modal element
 */
function cwFocusName(modalEl) {
    const listNameInput = queryFirst('#list-name', modalEl || queryFirst(`#${CW_MODAL_ID}`));

    if (!listNameInput) {
        return;
    }

    try {
        listNameInput.focus({ preventScroll: true });
    } catch {
        listNameInput.focus();
    }
}

/**
 * Handles creating wish list action
 */
function handleCreateWishList() {
    const createNewCollection = queryFirst('.create-list-collection');
    const listNameInput = queryFirst('#list-name');
    const invalidFeedback = queryFirst('.invalid-feedback', createNewCollection);
    const sheetContainer = queryFirst('.wishlist-sheet');
    const $createListSheetBody = $('#create-wishlist .sheet-body').first();
    listNameInput.value = '';
    removeClass(sheetContainer, INVALID_CLASS);
    removeClass(listNameInput, INVALID_CLASS);
    invalidFeedback.textContent = '';
    listNameInput.addEventListener('blur', function (e) {
        validateInputCallback(listNameInput, invalidFeedback);
    });

    async function createNewList(e) {
        e.preventDefault();
        const createCollectionLink = configElement?.dataset?.createCollectionLink || '';
        if (!createCollectionLink) {
            return;
        }
        let listName = listNameInput.value && listNameInput.value.trim();

        if (!listName || !WISHLIST_NAME_REGEX.test(listName)) {
            addClass(sheetContainer, INVALID_CLASS);
            return;
        }

        invalidFeedback.textContent = '';

        removeClass(sheetContainer, INVALID_CLASS);
        removeClass(listNameInput, INVALID_CLASS);
        listName = listName.replace(/\s\s+/g, ' ');
        $createListSheetBody.spinner().start();
        const csrfToken = await getFreshCsrfToken();

        const form = {
            wishlistName: listName,
            csrf_token: csrfToken
        };

        await fetch(createCollectionLink, {
            method: 'POST',
            body: toFormData(form)
        })
            .then(response => response.json())
            .then(data => {
                $createListSheetBody.spinner().stop();

                if (data.csrfError) {
                    document.body.dispatchEvent(new CustomEvent('csrf:error'));
                    return;
                }
                if (data.success) {
                    const wishlistMgr = WishlistItemsMgr.getInstance();
                    wishlistMgr.updateWishlistItems(data.wishlistItems);

                    const wishlistShowLink = configElement?.dataset?.wishlistShowLink || '';
                    if (wishlistShowLink) {
                        const url = new URL(wishlistShowLink, window.location.origin);
                        url.searchParams.set('id', data.wishListUUID);
                        $('#create-wishlist').one('hidden.bs.modal', function wishlistCreateNavigateAfterClose() {
                            $.spinner().start();
                            window.location.href = url.toString();
                        });
                        $('#create-wishlist').modal('hide');
                    }
                } else {
                    invalidFeedback.textContent = data.msg;
                    addClass(listNameInput, INVALID_CLASS);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    $(queryFirst('.wishlist-sheet'))
        .off('click submit')
        .on('click', '.add-new-list', createNewList)
        .on('submit', 'form.wishlist-create-form', createNewList);
}

/**
 * Handles editing wish list action
 */
function handleEditWishList() {
    const editCollection = queryFirst('.edit-list-collection');
    const listNameInput = queryFirst('#list-name', editCollection);
    const sheetContainer = queryFirst('.wishlist-sheet');
    const $editListSheetBody = $('#edit-wishlist .sheet-body').first();
    const invalidFeedback = queryFirst('.invalid-feedback', editCollection);
    removeClass(sheetContainer, INVALID_CLASS);
    removeClass(listNameInput, INVALID_CLASS);
    invalidFeedback.textContent = '';
    listNameInput.addEventListener('blur', function (e) {
        validateInputCallback(listNameInput, invalidFeedback);
    });

    $(queryFirst('.wishlist-sheet-edit')).on('click', '.js-edit-list', async function (e) {
        e.preventDefault();
        const editCollectionLink = configElement?.dataset?.editCollectionLink || '';
        const { listId: id } = this.dataset;
        if (!editCollectionLink || !id) {
            return;
        }
        let listName = listNameInput.value && listNameInput.value.trim();

        if (!listName || !WISHLIST_NAME_REGEX.test(listName)) {
            addClass(sheetContainer, INVALID_CLASS);
            return;
        }
        invalidFeedback.textContent = '';

        removeClass(sheetContainer, INVALID_CLASS);
        removeClass(listNameInput, INVALID_CLASS);
        listName = listName.replace(/\s\s+/g, ' ');
        $editListSheetBody.spinner().start();
        const csrfToken = await getFreshCsrfToken();

        const form = {
            id,
            wishlistName: listName,
            csrf_token: csrfToken
        };
        await fetch(editCollectionLink, {
            method: 'POST',
            body: toFormData(form)
        })
            .then(response => response.json())
            .then(data => {
                $editListSheetBody.spinner().stop();

                if (data.csrfError) {
                    document.body.dispatchEvent(new CustomEvent('csrf:error'));
                    return;
                }
                if (data.success) {
                    const wishlistMgr = WishlistItemsMgr.getInstance();
                    wishlistMgr.updateWishlistItems(data.wishlistItems);
                    $('#edit-wishlist').one('hidden.bs.modal', function wishlistEditReloadAfterClose() {
                        $.spinner().start();
                        window.location.reload();
                    });
                    $('#edit-wishlist').modal('hide');
                } else {
                    invalidFeedback.textContent = data.msg;
                    addClass(listNameInput, INVALID_CLASS);
                }
            })
            .catch(error => {
                $editListSheetBody.spinner().stop();
                $('#edit-wishlist').modal('hide');
                console.error('Error:', error);
            });
    });
    $(queryFirst('.wishlist-sheet-edit')).on('click', '.js-remove-list', function (e) {
        e.preventDefault();
        addClass(queryFirst('.js-wishlist-edit-item'), HIDDEN_CLASS);
        addClass(queryFirst('.js-edit-action'), HIDDEN_CLASS);
        removeClass(queryFirst('.js-wishlist-remove-confirmation'), HIDDEN_CLASS);
        removeClass(queryFirst('.js-wishlist-confirm-action'), HIDDEN_CLASS);
    });
    $(queryFirst('.wishlist-sheet-edit')).on('click', '.js-confirm-remove', async function (e) {
        e.preventDefault();
        const removeCollectionLink = configElement?.dataset?.removeCollectionLink || '';
        const { listId: id } = this.dataset;
        if (!removeCollectionLink || !id) {
            return;
        }
        $editListSheetBody.spinner().start();
        const csrfToken = await getFreshCsrfToken();

        const form = {
            id,
            csrf_token: csrfToken
        };
        await fetch(removeCollectionLink, {
            method: 'POST',
            body: toFormData(form)
        })
            .then(response => response.json())
            .then(data => {
                $editListSheetBody.spinner().stop();
                if (data.csrfError) {
                    document.body.dispatchEvent(new CustomEvent('csrf:error'));
                    return;
                }
                if (data.success) {
                    const loggedIn = queryFirst('.js-account-active') || queryFirst('.username');
                    const dataset = configElement?.dataset;
                    const showCollectionsLink = (loggedIn ? dataset?.wishlistsShowLoggedInLink : dataset?.wishlistsShowLink) || '';
                    if (!showCollectionsLink) {
                        return;
                    }
                    const wishlistMgr = WishlistItemsMgr.getInstance();
                    wishlistMgr.updateWishlistItems(data.wishlistItems);
                    const url = new URL(showCollectionsLink, window.location.origin);
                    history.replaceState({}, '', url.toString());
                    $('#edit-wishlist').one('hidden.bs.modal', function wishlistRemoveReloadAfterClose() {
                        $.spinner().start();
                        window.location.reload();
                    });
                    $('#edit-wishlist').modal('hide');
                } else {
                    $('#edit-wishlist').modal('hide');
                }
            })
            .catch(error => {
                $('#edit-wishlist').modal('hide');
                $editListSheetBody.spinner().stop();
                console.error('Error:', error);
            });
    });
    $(queryFirst('.wishlist-sheet-edit')).on('click', '.js-cancel-remove', function (e) {
        $('#edit-wishlist').modal('hide');
    });
}

/**
 * Creates a mobile sheet for displaying wishlist item details and actions.
 * This function clones the wishlist item container, populates the modal with its content,
 * and updates the availability and actions (e.g., "Add to Cart", "Notify Me") based on the product's inventory.
 *
 * @param {HTMLElement} button - The button element that triggered the action.
 */
async function createMobileSheet(button) {
    const wishlistCardContainer = button.closest('.wishlist-card-container');
    const modalItemsContainer = queryFirst('.js-wishlist-item-container');
    const container = button.closest('.product-info');
    const { colorId, masterId } = container.dataset;

    const productInfoVariants = getProductInfo(container);
    const product = productInfoVariants ? productInfoVariants[colorId] : null;
    const productInventory = await getProductInventoryData(masterId);
    const sheetAddToTote = queryFirst('.js-sheet-add-tote');
    modalItemsContainer.innerHTML = '';
    sheetAddToTote.innerHTML = '';
    const wishlistCloneContainer = wishlistCardContainer.cloneNode(true);
    modalItemsContainer.innerHTML = wishlistCloneContainer.outerHTML;
    const addToToteButtons = queryFirst('.add-to-cart-wishList', modalItemsContainer);

    if (addToToteButtons) {
        sheetAddToTote.appendChild(addToToteButtons);
        const sheetAddToToteBtn = queryFirst('.js-add-to-cart', addToToteButtons);
        const sheetNotifyBtn = queryFirst('.js-wishlist-notify-me', addToToteButtons);
        sheetAddToToteBtn.disabled = true;
        removeClass(sheetAddToToteBtn, HIDDEN_CLASS);
        addClass(sheetNotifyBtn, HIDDEN_CLASS);
    }
    const notifyMeButton = queryFirst('.js-wishlist-notify-me', wishlistCardContainer);

    queryAll(SELECTOR_SIZE_BTN, modalItemsContainer).forEach(btn => {
        const { valueId: selectedSizeValue } = btn.dataset;
        const { message: availabilityMessage, availabilityStatus, isLowInventory } = productInventory.variants[product.sizes[selectedSizeValue].ID];
        const { isNotifyMeEnabled } = product.sizes[selectedSizeValue];

        const isInStockAvailability = availabilityStatus === IN_STOCK;
        const isNotAvailableAvailability = availabilityStatus === NOT_AVAILABLE;
        if (!isInStockAvailability || isLowInventory) {
            const newSpan = document.createElement('span');
            newSpan.textContent = availabilityMessage;
            addClass(newSpan, 'js-sheet-availability-msg', 'wishlist-sheet-availability');
            if (isNotAvailableAvailability) {
                btn.disabled = true;
                addClass(newSpan, NOT_AVAILABLE_CLASS);
            }
            const btnWrapper = btn.parentElement;
            btnWrapper.appendChild(newSpan);

            if (isNotAvailableAvailability && isNotifyMeEnabled) {
                const notifyMeButtonClone = notifyMeButton.cloneNode(true);
                removeClass(notifyMeButtonClone, HIDDEN_CLASS);
                removeClass(notifyMeButtonClone, 'js-desktop-notify-me');
                addClass(notifyMeButtonClone, 'valid-data');
                btnWrapper.appendChild(notifyMeButtonClone);
            }
        }
    });

    $('#wishlists-add-to-cart').modal('show');
}

export default {
    /**
     * Old event start need to verify if they still actual after redisign
     */

    viewProductViaEdit: function () {
        $body.on('click', '.edit-add-to-wishlist .edit', function (e) {
            e.preventDefault();

            const editProductUrl = $(this).attr('href');
            $(e.target).trigger('editwishlistproduct:show');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    viewProductViaSelectAttribute: function () {
        $body.on('click', '.select-attributes-btn', function (e) {
            e.preventDefault();

            const editProductUrl = $(this).data('get-product-url');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    focusEditWishlistProductModal: function () {
        $body.on('shown.bs.modal', '#editWishlistProductModal', function () {
            $('#editWishlistProductModal').siblings().attr('aria-hidden', 'true');
            $('#editWishlistProductModal .close').focus();
        });
    },

    onClosingEditWishlistProductModal: function () {
        $body.on('hidden.bs.modal', '#editWishlistProductModal', function () {
            $('#editWishlistProductModal').remove();
            $('.modal-backdrop').remove();
            $body.removeClass('modal-open');

            $('#editWishlistProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapEditWishlistProductModalFocus: function () {
        $body.on('keydown', '#editWishlistProductModal', function (e) {
            const focusParams = {
                event: e,
                containerSelector: '#editWishlistProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.btn-update-wishlist-product',
                nextToLastElementSelector: '.select-size'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    updateWishlistUpdateButton: function () {
        $body.on('product:updateAddToCart', function (e, response) {
            response.$productContainer.find('.btn-update-wishlist-product').attr('disabled', !response.product.readyToOrder || !response.product.available);
        });
    },

    updateWishListItem: function () {
        $body.on('click', '.btn-update-wishlist-product', async function (e) {
            e.preventDefault();

            const updateButtonBlock = $(this).closest('.wishlist-item-update-button-block').find('.update-wishlist-url');
            const updateProductUrl = updateButtonBlock.val();
            const uuid = updateButtonBlock.data('uuid');

            const csrfToken = await getFreshCsrfToken();

            const form = {
                uuid: uuid,
                pid: base.getPidValue($(this)),
                csrf_token: csrfToken
            };

            $('#editWishlistProductModal').spinner().start();

            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function () {
                    $.spinner().start();
                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $body.removeClass('modal-open');
                    const pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                    renderNewPageOfItems(pageNumber, '.product-info .edit-add-to-wishlist .edit:first');
                },
                error: function (err) {
                    if (err?.responseJSON?.csrfError) {
                        $('#editWishlistProductModal').spinner().stop();
                        document.body.dispatchEvent(new CustomEvent('csrf:error'));
                        return;
                    }
                    const msg = $('.btn-update-wishlist-product').data('error-msg');

                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $body.removeClass('modal-open');

                    if ($('.update-wishlist-messages').length === 0) {
                        $body.append('<div class="update-wishlist-messages "></div>');
                    }

                    $('.update-wishlist-messages').append('<div class="update-wishlist-alert text-center alert-danger">' + msg + '</div>');

                    setTimeout(function () {
                        $('.update-wishlist-messages').remove();
                    }, 5000);
                }
            });
        });
    },
    /**
     * Old event end need to verify if they still actual after redisign
     */
    handleWishlistsModalAction: function () {
        const $createWishlistModal = $(`#${CW_MODAL_ID}`);

        $createWishlistModal
            .off('show.bs.modal.lpWishlistCreate shown.bs.modal.lpWishlistCreate hidden.bs.modal.lpWishlistCreate')
            .on('show.bs.modal.lpWishlistCreate', function () {
                cwSyncExpanded(true);
            })
            .on('shown.bs.modal.lpWishlistCreate', function () {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => cwFocusName(this));
                });
            })
            .on('hidden.bs.modal.lpWishlistCreate', function () {
                cwSyncExpanded(false);
            });

        $body.on('click', '.js-create-wishlist', function (e) {
            e.preventDefault();
            $createWishlistModal.modal('show');
            handleCreateWishList();
        });
        $body.on('click', '.js-edit-wishlist', function (e) {
            removeClass(queryFirst('.js-wishlist-edit-item'), HIDDEN_CLASS);
            removeClass(queryFirst('.js-edit-action'), HIDDEN_CLASS);
            addClass(queryFirst('.js-wishlist-remove-confirmation'), HIDDEN_CLASS);
            addClass(queryFirst('.js-wishlist-confirm-action'), HIDDEN_CLASS);
            $('#edit-wishlist').modal('show');
            const { uuid, name: listName } = this.dataset;
            handleEditWishList(listName, uuid);
        });
        $body.on('click', '.js-share-wishlist', async function (e) {
            e.preventDefault();
            e.stopPropagation();
            const button = this;
            const { shareUrl, shareTitle, shareText, sharePublic, listUuid } = button.dataset;

            if (sharePublic !== 'true') {
                const url = configElement?.dataset?.wishlistsTogglePublic || '';
                if (!url) {
                    return;
                }
                const csrfToken = await getFreshCsrfToken();
                await fetch(url, {
                    method: 'POST',
                    body: toFormData({
                        listID: listUuid,
                        csrf_token: csrfToken
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.csrfError) {
                            document.body.dispatchEvent(new CustomEvent('csrf:error'));
                            return;
                        }
                        if (!data.error) {
                            button.dataset.sharePublic = 'true';
                            showShareDialogs(shareTitle, shareText, shareUrl);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            } else {
                showShareDialogs(shareTitle, shareText, shareUrl);
            }
        });
    },
    copyShareLink: function () {
        $('#share-wishlist').on('click', '.js-copy-link', () => {
            const { value: copyShareLinkText } = queryFirst('.js-copy-text').dataset;

            /* Copy the text */
            navigator.clipboard.writeText(copyShareLinkText);
            $('#share-wishlist').modal('hide');
        });
    },
    titleDropDown: function () {
        $body.on('click', '.js-collection-header', () => {
            toggleClass(queryFirst('.js-wishlists-dropdown'), HIDDEN_CLASS);
        });
        // Handle click outside the dropdown and header
        $body.on('click', e => {
            const collectionHeader = queryFirst('.js-collection-header');
            const dropdown = queryFirst('.js-wishlists-dropdown');

            // Check if the click is outside the header and dropdown
            if (dropdown && collectionHeader && !collectionHeader.contains(e.target) && !dropdown.contains(e.target)) {
                // Add the hidden class if clicked outside
                addClass(dropdown, HIDDEN_CLASS);
            }
        });
    },
    selectedList: function () {
        $body.on('click', '.alert-dialog-text', function (e) {
            $body.trigger('wishlist:viewselected');
        });
    },
    removeFromWishlist: function () {
        $body.on('click', '.js-remove-from-wishlist', async function (e) {
            e.preventDefault();
            const { target } = e;
            const { url, uuid, listId, undoMessage, pid, undoEnabled } = target.dataset;
            const csrfRefresh = await ensureFreshCsrfToken();
            const ajaxData = queryFirst('.js-ajax-data');
            const csrfToken = ajaxData?.dataset?.csrfTokenValue;
            const form = {
                uuid,
                id: listId,
                csrf_token: csrfToken
            };

            $.spinner().start();
            let data;
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    body: toFormData(form)
                });
                data = await response.json();
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                if (data.success) {
                    updateWishlistCountMessage(data.wishListCountMessage);

                    if (!data.wishlistItems.find(i => i.UUID === listId).items.length) {
                        addClass(queryFirst('.js-share-wishlist'), HIDDEN_CLASS);
                    }

                    // Update Marketing Cloud Analytics trackWishlist event
                    trackWishlist(data.marketingCloudAnalyticsData);

                    // Update the wishlist manager items
                    const wishlistMgr = WishlistItemsMgr.getInstance();
                    wishlistMgr.updateWishlistItems(data.wishlistItems);

                    // Get the current page number and next item
                    const pageNumber = (queryFirst('.wishlistItemCardsData')?.dataset?.pageNumber || 1) - 1;
                    const itemToRemove = queryFirst(`#wishlist-card-${uuid}`);
                    const nextItem = itemToRemove.nextElementSibling;

                    // Render the new page of items
                    await renderNewPageOfItems(pageNumber, null, nextItem);

                    const alertConfig = {
                        alertTimeout: 5000,
                        items: [
                            {
                                text: undoMessage,
                                cta: undoEnabled === 'true' ? [
                                    {
                                        text: 'Undo',
                                        callback: async () => {
                                            await addProductToWishlist(pid, listId, data.itemCreateTime);
                                            await renderNewPageOfItems(pageNumber, null, itemToRemove);
                                        }
                                    }
                                ] : [],
                                icon: queryFirst('.tile-image img', itemToRemove)
                            }
                        ],
                        customCSSClass: ['wishlist-alert-dialog-removed'],
                        focusAfterClose: nextItem,
                        remainOnScroll: true
                    };

                    displayAlert(alertConfig);
                } else {
                    $.spinner().stop();
                    displayAlert(getErrorAlertConfig());
                }
            } catch (error) {
                // Handle network or response error
                // Handle error case: Show an alert with error message
                console.error('Error:', error);

                $.spinner().stop();
                if (data?.csrfError) {
                    $body.trigger('csrf:error');
                } else {
                    displayAlert(getErrorAlertConfig());
                }
            }
        });
    },
    selectSizeAttribute: function () {
        $body.on('click', SELECTOR_SIZE_BTN, async function (e) {
            e.preventDefault();
            if (!hasClass(this, 'selected')) {
                const el = e.currentTarget;
                const productTile = el.closest('.product-info');
                const { attrValue: selectedSizeValue } = el.dataset;

                await onSizeChangeHandler(productTile, el, selectedSizeValue);
            }
        });
    },
    validateEmail: notifyMe.validateEmail,
    notifyMeSubmit: notifyMe.notifyMeSubmit,
    setNotifyMeProductDetails: function () {
        const customerEmail = (document.getElementById('notifyEmail') || {}).value;
        if (customerEmail) {
            const notifyEmail = queryFirst('.notify-email');
            if (notifyEmail) notifyEmail.value = customerEmail;
        }
        $body.on('click', '.js-wishlist-notify-me.valid-data', (e) => {
            e.preventDefault();
            const el = e.currentTarget;
            const container = el.closest('.product-info');
            const { colorId } = container.dataset;

            const productInfoVariants = getProductInfo(container);
            const product = productInfoVariants ? productInfoVariants[colorId] : null;
            const selectedSizeValue = queryFirst('.size-btn.selected', container)?.dataset?.attrValue || queryFirst('.size-btn', this.parentElement)?.dataset?.attrValue;
            const pid = product.sizes[selectedSizeValue].ID;

            const pidInput = queryFirst(SELECTOR_NOTIFY_ME_DIALOG_PID_INPUT);
            pidInput.value = pid;
            $('#wishlists-add-to-cart').modal('hide');
            $('.js-notify-me-dialog-wrapper').modal('show');
            return true;
        });
        $body.on('click', '.js-wishlist-notify-me', async function (e) {
            if (!matchesBreakpoint('lg') && !hasClass(this, 'valid-data')) {
                await createMobileSheet(this);
            } else {
                e.preventDefault();
                return false;
            }
            return true;
        });
    },
    addToCartFromWishlist: function () {
        $body.on('click', '.js-add-to-cart.valid-data', function (e) {
            $.spinner().start();

            $body.trigger('product:beforeAddToCart', this);

            const container = this.closest('.product-info') || queryFirst('.product-info', this.closest('.wishlist-sheet'));
            const { colorId } = container.dataset;

            const productInfoVariants = getProductInfo(container);
            const product = productInfoVariants ? productInfoVariants[colorId] : null;
            const selectedSizeValue = queryFirst('.size-btn.selected', container)?.dataset?.attrValue;
            const pid = product.sizes[selectedSizeValue].ID;
            const { url, uuid, wishlistId } = this.dataset;
            const itemToRemove = queryFirst(`#wishlist-card-${uuid}`);
            const ajaxData = queryFirst('.js-ajax-data');
            const csrfToken = ajaxData?.dataset?.csrfTokenValue;

            const form = {
                pid,
                wishlistUUID: uuid,
                listID: wishlistId,
                csrf_token: csrfToken
            };

            if (this.dataset.option) {
                form.options = JSON.stringify(this.dataset.option);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (url) {
                getJSON(
                    url,
                    'POST',
                    form,
                    async data => {
                        if (itemToRemove) {
                            const { removedWishListItem } = data;
                            if (removedWishListItem) {
                                const pageNumber = (queryFirst('.wishlistItemCardsData')?.dataset?.pageNumber || 1) - 1;

                                const nextItem = itemToRemove.nextElementSibling;
                                await renderNewPageOfItems(pageNumber, null, nextItem);
                                updateWishlistCountMessage(data.wishListCountMessage);
                            }
                        }
                        handlePostCartAdd(data);
                        $body.trigger('product:afterAddToCart', data);
                        $('#wishlists-add-to-cart').modal('hide');
                        $.spinner().stop();
                    },
                    data => {
                        if (data?.responseJSON?.csrfError) {
                            $body.trigger('csrf:error');
                        }
                        $.spinner().stop();
                    }
                );
            }
        });
        $body.on('click', '.js-add-to-cart', async function (e) {
            if (!matchesBreakpoint('lg') && !hasClass(this, 'valid-data')) {
                await createMobileSheet(this);
            } else {
                e.preventDefault();
                return false;
            }
            return true;
        });
    },
    moreWLItems: function () {
        $body.on('click', '.more-wishlist-items', e => {
            const { target } = e;
            const { pageNumber } = target.dataset;
            $.spinner().start();
            renderNewPageOfItems(pageNumber);
        });
    }
};
